<template>
  <div>
    <ul class="timeline mb-5">
      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">SINERGIA SAS</span>
            <span class="time-wrapper">
              <span class="time">Actualmente</span>
            </span>
          </div>
          <div class="desc">
            Desarrollador web Full Stack Java Spring Boot implementando
            microservicios, JPA, Hibernate, liquibase, Laravel y Angular 12,
            lazyloading, primeNG y Postgres como base de datos. encargado de
            multiples tareas de back y front
          </div>
        </div>
      </li>

      <li>
        <div class="direction-l">
          <div class="flag-wrapper">
            <span class="flag">Logan It Solutions.</span>
            <span class="time-wrapper">
              <span class="time">Junio 2020 - Julio 2021</span>
            </span>
          </div>
          <div class="desc">
            Desarrollador Front-End, trabajando sistemas de rastreo y gestión de
            envíos, usando la tecnología de Angular en su versión 8 y diseñando
            la interfaz gráfica.
          </div>
        </div>
      </li>

      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">La Liebre</span>
            <span class="time-wrapper">
              <span class="time">2020</span>
            </span>
          </div>
          <div class="desc">
            Desarrollador web encargado de crear un sistema para gestión de
            tienda online y API en NODE con express para la parte móvil.
          </div>
        </div>
      </li>

      <li>
        <div class="direction-l">
          <div class="flag-wrapper">
            <span class="flag">Geostigma Media</span>
            <span class="time-wrapper">
              <span class="time">2020</span>
            </span>
          </div>
          <div class="desc">
            Desarrollador full stack, desarrollando sistemas CRM a medida,
            creación de API con express y mysql.
          </div>
        </div>
      </li>

      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">MyT Medica</span>
            <span class="time-wrapper">
              <span class="time">2020</span>
            </span>
          </div>
          <div class="desc">
            Desarrollador web encargado de desarrollar la creacion de sistema
            para el área de la salud, consumiendo APIs externas con Node usando
            TypeORM.
          </div>
        </div>
      </li>

      <li>
        <div class="direction-l">
          <div class="flag-wrapper">
            <span class="flag">Creasis</span>
            <span class="time-wrapper">
              <span class="time">2019</span>
            </span>
          </div>
          <div class="desc">
            Empresa propia enfocada en el desarrollo web, móvil y producción de
            multimedia.
          </div>
        </div>
      </li>

      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">SOMAC SAS</span>
            <span class="time-wrapper">
              <span class="time">2019</span>
            </span>
          </div>
          <div class="desc">
            Único programador encargado de realizar un sistema contable para
            sectores públicos y privados, desarrollando módulos como: Terceros,
            Catálogo de Cuentas, Presupuestos, Roles, entre otros módulos,
            Diseño de interfaz de usuario y modelado de base de datos.
          </div>
        </div>
      </li>

      <li>
        <div class="direction-l">
          <div class="flag-wrapper">
            <span class="flag">Finantec SAS</span>
            <span class="time-wrapper">
              <span class="time">2018 - 2019</span>
            </span>
          </div>
          <div class="desc">
            Desarrollador web encargado de realizar sistemas usando Laravel;
            dando asesoría y acompañamiento a nuevos integrantes de la empresa,
            desarrollo de funcionalidades en .NET, diseños de interfaces,
            promotor de buenas prácticas como Git,y Trello.
          </div>
        </div>
      </li>

      <li>
        <div class="direction-r">
          <div class="flag-wrapper">
            <span class="flag">Geostigma Media</span>
            <span class="time-wrapper">
              <span class="time">2018</span>
            </span>
          </div>
          <div class="desc">
            Auxiliar de desarrollo, encargado de las funciones de sistema
            institucional, redacción de documentos, introducción a SEO,
            maquetado web.
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Experiencia",
};
</script>
<style lang="scss">
@import "../assets/expetiencia.scss";
</style>